import React, { createContext, memo, useCallback, useReducer, useMemo, useEffect } from 'react';
import { pageEditActions } from './types';
import { defaultPageEditState, pageEditReducer } from './pageEditReducer';
import { pageActions, usePage } from '../';
import { toast, useAuth } from '../../../';
var store = createContext({
    pageEdit: defaultPageEditState,
    dispatchPageEdit: function () {
    },
    onPageChange: function () {
    }
});
var Provider = store.Provider;
export var usePageEdit = function () {
    var _a = React.useContext(store), pageEdit = _a.pageEdit, dispatchPageEdit = _a.dispatchPageEdit, onPageChange = _a.onPageChange;
    var pageInEditMode = useMemo(function () { return pageEdit.enabled; }, [pageEdit.enabled]);
    return { pageEdit: pageEdit, dispatchPageEdit: dispatchPageEdit, onPageChange: onPageChange, pageInEditMode: pageInEditMode };
};
export var PageEditProvider = memo(function (_a) {
    var children = _a.children;
    var dispatchPage = usePage().dispatchPage;
    var _b = useReducer(pageEditReducer, defaultPageEditState), pageEdit = _b[0], dispatchPageEdit = _b[1];
    var auth = useAuth().auth;
    useEffect(function () {
        if (pageEdit.enabled && !auth.user)
            dispatchPageEdit({ type: pageEditActions.TOGGLE_EDIT, enabled: false });
    }, [auth.user, dispatchPageEdit, pageEdit.enabled]);
    var onPageChange = useCallback(function (_a) {
        var data = _a.data, error = _a.error;
        if (error) {
            toast.error(error);
        }
        else {
            dispatchPage({ type: pageActions.UPDATE, data: data });
        }
    }, [dispatchPage]);
    return (React.createElement(Provider, { value: { pageEdit: pageEdit, dispatchPageEdit: dispatchPageEdit, onPageChange: onPageChange } }, children));
});
